/**
 * Declare Variable
 */
const messages = {
  weekdays: {
    sunday: 'Sunday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
  },
  times: {
    minute: ':00',
    to: 'to',
    '24hr': 'Open for 24 hours',
  },
  'toast.promocode.lessThanMinOrderAmount': 'You have not reached the minimum order amount of ${amt} for discount.',
  dialog: {
    'get_quotation_error.title': 'Get Quotation Error',
    'get_quotation_error.message': 'Back to directory page.',
    'promocode.lessThanMinOrderAmount':
			'You have not reached the minimum order amount of ${amt} for discount. Do you want to continue to add more items or check out directly?',
    'promocode.addOrder': 'Add Order',
    'promocode.removePromocode': 'Remove Promocode',
    'promocode.removePromocode.message': 'Are you sure about not to use this promocode?',
    'promocode.continuePay': 'Continue to Pay',
    confirm_btn: 'Confirm',
    cancel_btn: 'Cancel',
    continue_btn: 'Continue',
    'no_available_shipping.title': 'No Available Shipping',
    'no_available_shipping.message': 'Sorry, we cannot find available shipping to your district.',
    'no_current_location.title': 'Cannot locate your current position',
    'no_current_location.message': 'Please enable location service on your device, or enter your address directly',
    sold_out_title: 'Sorry, below items are not available. Continue your submission without these items?',
    all_sold_out_title: 'Sorry, all selected item is just sold out.',
    hint: 'Hint',
    warning: 'Warning',
    rescan: 'Please scan the QRCode again',
    joinbasketErr: 'Cannot join the order, Please scan the QRCode again',
    noMerchant: 'Restaurant is not available',
    reorder: 'Re-Order',
    reorder_msg_front: 'Confirm table',
    reorder_msg_back: 'to re-order',
    reorder_msg_takeaway: 'Re-order takeaway',
    confirm_clear_order_all: 'Confirm to clear order all?',
    choose_delete_dish_option: 'Select to remove a option/ remark',
    remind: 'Remind',
    go_back: 'Cancel',
    reorder_step: 'Set menu is not complete. Please confirm to reset all changes.',
    'dineIn.unavailable.title': 'Thank you for using DimOrder.',
    'dineIn.unavailable.msg': 'We are sorry that dine-in service is currently suspended by the restaurant. Please try again later or contact the restaurant at +852 ',
    'takeaway.unavailable.title': 'Thank you for using DimOrder.',
    'takeaway.unavailable.msg':
			'We are sorry that takeaway service is currently suspended by the restaurant. Please try again later or contact the restaurant at +852 ',
    'delivery.unavailable.title': 'Thank you for using DimOrder.',
    'delivery.unavailable.msg':
			'We are sorry that delivery service is currently suspended by the restaurant. Please try again later',
    option_div_none: 'None',
    scan_result: 'Scan Result',
    rescan_btn: 'Rescan',
    pickup_code: 'Pickup code',
    pickup_success: 'Pickup success',
    pickup_failed: 'Pickup failed',
    pickup_error_status: {
      402: 'Invalid code',
      403: 'Order missing',
      500: 'Pickup already',
    },
    camera_failure: "Can't connect to the camera",
    invalid_card_number_title: '信用卡輸入錯誤',
    invalid_card_number_message: '提醒您！本活動僅限使用中國建設銀行(亞洲) VISA/Master 信用卡。',
    hotel_passcode: 'Please enter 4 digit passcode:',
    hotel_passcode_error: 'Invalid passcode',
  },
  history: {
    order_recent: 'Recent Order',
    order: 'Order',
    table_no: 'Table',
    room_no: 'Room',
    order_paid: 'Paid',
  },
  checkout: {
    especial_title: 'Favorite Options',
    today: 'Today',
    total_of_front: 'Total ',
    'total_of_front.takeaway': 'Total (',
    total_of_back: 'of Dish',
    total_of_back2: 'of Item',
    'total_of_back.takeaway': 'of Dish)',
    total_choose_front: 'Total of',
    total_choose_back: ' ',
    total_choose_back2: ' ',
    empty_order: 'No order found, go back to order!',
    clear_order_all: 'Clear All',
    remark: 'Input any special request here',
    surcharge: 'Surcharge',
    discount: 'Discount',
    serial: 'Invoice No.',
    code: 'Token',
    'status.pending': 'Pending',
    'status.paid': 'Paid',
    'status.ready': 'Ready',
    'status.completed': 'Collected',
    'status.delivered': 'Delivered',
    'status.cancelled': 'Cancelled',
    'method.visa': 'Visa',
    'method.unionpay': 'UnionPay',
    'method.master': 'Master',
    'method.unknown': 'Unknown',
    'method.ae': 'American Express',
    'method.alipay': 'Alipay',
    'method.wechat': 'Wechat Pay',
    'method.wechatpay': 'Wechat Pay',
    'method.octopus': 'Octopus',
    'method.bypass': 'bypass',
    'method.cash': 'Pay at Cashier',
    'method.card': 'Credit Card',
    'method.creditsales': 'Credit Sales',
    'method.wechat.scan_to_pay': 'Open WeChat scan QRCode to pay',
    'hand.up.waiter': 'Waiter',
    'hand.up.pay': 'Check',
    reorder: 'Re-Order',
    'waiting.waiter.toast': 'Requested waiter, please wait a moment',
    'waiting.pay.toast': 'Requested for a check, please wait a moment',
    'pay.by.cash.confirm': 'Pay with cash at restaurant?',
    'item.remark': 'Remark',
  },
  summary: {
    'restaurant.info': 'Restaurant Information',
    'shop.info': 'Shop Information',
    'restaurant.info.name': 'Name',
    'restaurant.info.address': 'Address',
    'restaurant.info.delivery.address': 'Delivery Address',
    'restaurant.info.tel': 'Tel. No.',
    time: 'Time',
    deliveryType: 'Shipping Options',
    please_select: 'Please select',
    'deliveryType.takeaway': 'Takeaway',
    'deliveryType.delivery': 'Delivery',
    'deliveryType.shop': 'Delivery',
    'deliveryType.storeDelivery': 'Delivery',
    name: 'Name',
    date: 'Date',
    tel_placeholder: 'Contact Number',
    'undetermined.price': 'TBC',
    'remark.placeholder': 'Enter any special request',
    floorRoom: 'Floor or Room',
    companyBuilding: 'Company or Building',
    required: '(Required)',
  },
  changeTable: {
    inactiveTable: 'Available Table',
  },
  footer: {
    processing: 'Processing',
    change_table: 'Table',
    choose_table: 'Choose Table',
    choosing: 'Picking',
    no_of: 'No.of',
    step: 'step',
    set_no: ' ',
    choose: 'Go',
    still_not_choose_front: 'Still have',
    still_not_choose_back: '...',
    checkout: 'Checkout',
    checkout_immediate: 'Checkout Now',
    checkout_confirm: 'Confirm',
    checkout_confirm_booking: 'Confirm',
    checkout_submiting: 'Submiting',
    table_no: 'Table {value}',
    room_no: 'Room {value}',
    takeaway_no: 'Takeaway',
    dish_no: 'dishes',
    item_no: 'items',
    total_of_front: 'Total ',
    'total_of_front.takeaway': 'Total (',
    total_of_back: 'Dishes',
    total_of_back2: ' Items',
    'total_of_back.takeaway': 'Dishes)',
    'hand.up.waiter': 'Waiter',
    'hand.up.pay': 'Pay',
    'takeaway.confirm.pay': 'Confirm',
    waiting_for_payment: 'Waiting for payment',
    other_restaurants: 'Other Restaurants',
    confirm: 'Confirm',
    waiting_for_table: 'Scan QRCode on table to confirm',
    remaining_prefix: ' ',
    remaining_suffix: ' Left',
    skipAll: 'Skip All',
  },
  confirmation: {
    success: 'Successful',
    success_submit_order: 'Success to submit order,',
    success_description: 'It need takes time to make food, please wait patiently.',
    success_hotel_description: 'Please wait patiently.',
    continue_order: 'Continue Order',
    view_history: 'View History',
    go_back: 'GO BACK',
  },
  rightSideBar: {
    order_history: 'Order History',
    menus: 'Menus',
  },
  categoryDetailList: {
    promo: 'Hot',
    no_category_list: 'Sorry, Category not found.',
  },
  navBarLite: {
    complete: 'Complete',
    edit: 'Edit',
    'me.only': 'Me',
    all: 'All',
  },
  navBarSwiper: {
    hot_sale: 'Hot Sale',
    all_category: 'All Categories',
  },
  stepper: {
    confirm_submit: 'Confirm Submit',
    sold_out: 'Sold Out',
    back: 'Back',
  },
  about: {
    address: 'Address',
    phone: 'Phone',
    opening: 'Openings',
  },
  error: {
    general: 'Oops, something went wrong',
    'submit too fast': 'You are trying to submit too fast. Try again in {batchInterval}',
    'invalid.timeslot': 'Order time has gone',
    'invalid.amount_too_small': 'The Order is below minimum purchase amount of ${minAmount}',
    'cutoff order': 'Order time has gone',
    stripe: {
      amount_too_small: 'The amount is lesser than $4.',
      authentication_required: 'Please contact the customer service of your credit card.',
      card_decline_rate_limit_exceeded:
				'Reached the maximum times of card authentication decline. Please contact the customer service of your credit card.',
      card_declined: 'The card was declined. Please contact the customer service of your credit card.',
      charge_already_captured: 'An error occurred when processing the card. (Error: 102)',
      charge_already_refunded: 'An error occurred when processing the card. (Error: 103)',
      charge_disputed: 'An error occurred when processing the card. (Error: 104)',
      charge_exceeds_source_limit: 'An error occurred when processing the card. (Error: 105)',
      charge_expired_for_capture:
				'The merchant must complete the order within 7 days or the payment cannot be captured.',
      charge_invalid_parameter: 'An error occurred when processing the card. (Error: 106)',
      customer_max_payment_methods:
				'The card is processing multiple orders currently. Please try again with another credit card.',
      customer_max_subscriptions: 'An error occurred when processing the card. (Error: 107)',
      expired_card: 'The card has expired.',
      incorrect_cvc: "The card's security code is invalid.",
      incorrect_number: 'The card number is incorrect.',
      incorrect_zip: "The card's zip code failed validation.",
      instant_payouts_unsupported:
				'This card does not support online payment. Please try another card or ccontact the customer service of your credit card.',
      intent_invalid_state: 'An error occurred when processing the card. (Error: 108)',
      intent_verification_method_missing: 'An error occurred when processing the card. (Error: 109)',
      invalid_card_type:
				'The credit card is not supported. Please try another card or ccontact the customer service of your credit card. ',
      invalid_charge_amount: 'The amount is lesser than $4.',
      invalid_cvc: "The card's security code is invalid.",
      invalid_expiry_month: "The card's expiration month is invalid.",
      invalid_expiry_year: "The card's expiration year is invalid.",
      invalid_number: 'The card number is not a valid credit card number.',
      order_creation_failed: 'An error occurred when processing the card. Please try again. (Error: 110)',
      order_required_settings: "The card's information is incorrect. Please try again. (Error: 112)",
      order_upstream_timeout: 'Process timeout. Please try again.',
      processing_error: 'An error occurred while processing the card.',
      token_already_used: 'An error occurred when processing the card. Please try again. (Error: 113)',
      token_in_use: 'An error occurred when processing the card. Please try again. (Error: 114)',
      transfers_not_allowed: 'An error occurred when processing the card. Please try again. (Error: 115)',
      upstream_order_creation_failed: 'An error occurred when processing the card. Please try again. (Error: 116)',
    },
  },
  lang: {
    en: 'English',
    zh: '繁體中文',
  },
  delivery: {
    'deliverystatus.enroute':
			'Your food is on its way! We will call you upon arrival. Delivery service hotline: 5267 1016',
    'deliverystatus.delivered': 'Food is delivered. Enjoy!',
    redbar: '- Daily free delivery at 12:30pm-2:00pm with cut off time at 11:20am.',
    redbar2: '- Self pick-up is available anytime!',
    redbar3: '- Delivery applicable to specific hospital and clinic',
    redbar4:
			'- Only medical staff can enjoy medical discount. Non-medical staff may be required to pay for the price difference',
  },
  storedelivery: {
    'status.completed': 'Your food is on its way! Our driver will contact you shortly.',
  },
  shop: {
    'status.completed': 'Your order is ready',
  },
  takeaway: {
    'summary.collapsed.header': 'Total',
    'toggle.button.title': 'Show',
    'toggle.button.title.hide': 'Hide',
    'summary.total.number': ' dish(es)',
    'summary.total.number.shop': ' item(s)',
    'summary.cardholder_placeholder': 'CARDHOLDER’S NAME',
    'summary.cardnum_placeholder': 'CARD NUMBER',
    'summary.card_expiration_placeholder': 'MM / YY',
    'summary.ccv_placeholder': 'CVV',
    'status.pending': 'Thank you for using DimOrder! Our merchant has received your order.',
    'status.confirmed': 'Our merchant will soon be preparing your order.',
    'status.ready': 'Your order is ready for pick up!',
    'status.cancelled':
			'We are very sorry that our merchant is unable to accept your order. For any enquiries, please call us at 5267 1016. Thank you!',
    'status.completed': 'Your order has been collected! Thank you for using DimOrder!',
    'status.delivered': 'Your order has been delivered! Thank you for using DimOrder!.',
    'summary.restaurant.code.header': 'Collection Token',
    'summary.pickup.time': 'Collection Time',
    'summary.pickup.status': 'Status',
    cancel_reason: 'Cancel Reason',
    'cancel.missing': 'Dishes not available',
    'cancel.busy': 'Too busy',
    'cancel.rejected': 'Shop Rejected',
    'cancel.closed': 'Shop closed',
    'cancel.other': 'Others',
    'summary.pay.with.recent.method': 'Pay by recent method',
    'payment.method.cash': 'Cash',
    'payment.method.cashier': 'Pay at Cashier',
    'payment.method.creditCard': 'Credit Card',
    'payment.method.wechatPay': 'WeChat Pay',
    'payment.method.applePay': 'Apple Pay',
    'payment.method.googlePay': 'Google Pay',
    'payment.method.comingsoon': 'Coming soon',
    'order.promo.code': 'Promo Code',
    'order.promo.memberpromo': 'Member Promotion',
    'order.promo.code.submit': 'Redeem',
    'order.promo.code.cancel': 'Cancel',
    'order.promo.code.invalid': 'Please check your promotion code',
    'request.delivery': 'Request for delivery',
    reorderAfterOrderComplete: 'You can re-order after the order is completed',
    reorder: 'Re-order',
    rechoose: 'Re-order',
    needTableware: 'Need tableware?',
  },
  shipping: {
    please_select_date: 'Please select a date',
    please_select_period: 'Please select a period',
    please_select_shipping: 'Please select a shpping',
    no_available_shipping: 'No available shipping method',
    shipping_service: 'Shipping service',
    minimun_charge: 'Minimun charge',
    shipping_fee: 'Shipping Fee',
    free_shipping: 'Free Shipping',
    freight_collect: 'Freight collect',
    please_fill_address: 'Please fill in your address',
    no_options_message: 'No Options',
  },
  bottomsheet: {
    'max.prefix': '(At most ',
    'min.prefix': '(At least ',
    suffix: ')',
    'max.min.and': ' - ',
  },
  carousel: {
    'set.btn': 'Set',
    'price.attr': 'up',
  },
  required: 'Required',
  notRequired: 'Not Required',
  searchText: 'Search by name or code',
  soldOutSoon: 'Sold Out Soon',
  tnc: {
    line1: 'By submitting the order, I understand and agree with the ',
    linkText: 'Terms and Conditions',
    line1AfterLink: ', and I acknowledge the order can not be cancelled once it is submitted.',
    line2: '',
  },
  merchantAccount: 'Merchant Account',
  account: 'Account',
  password: 'Password',
  login: 'Login',
  otherTableGroups: 'Others',
  'servicenotavailable.timeslot': 'Service is not available at this time',

  directory: {
    opening: {
      title: 'Takeaway / Delivery Openings',
      subtitle: {
        takeaway: 'Takeaway',
        delivery: 'Delivery',
      },
    },
    dateTimePicker: {
      title: {
        takeaway: 'Please Select Your Time',
        delivery: 'Please Select Your Time',
      },
      selectDate: {
        takeaway: 'Select A Date',
        delivery: 'Select A Date',
      },
      selectTime: {
        takeaway: 'Select A Time',
        delivery: 'Select A Time (Delivery time may vary depending on traffic and distance*)',
      },
      submit: 'Make Your Order',
    },
    selector: {
      immediate: 'Immediate',
      around45minDeliver: 'Deliver in Around 45 min*',
      around: 'Deliver in Around',
	    pickupAfter: 'Pickup After ',
      minDeliver: ' min*',
      minPickup: 'min*',
      noAvailableShipping: 'No shipping method available.',
    },
    bottomNavigation: {
      takeaway: 'Takeaway',
      takeawayDisable: ' - Unavailable',
      delivery: 'Delivery',
      shop: 'Shop',
      map: 'Map',
    },
  },

  waiter: {
    numberPad: {
      clear: 'Clear',
    },
  },
  loading: 'Loading',
  nextStep: 'Next Step',
  prevStep: 'Previous Step',
  updateMessage: 'Updates are available',
  update: 'Update',
  minus: 'Minus',

  wechatConfirmation: {
    message: 'Wechat Pay Confirmation',
    paid: 'Paid',
    error: 'Error when using Wechat Pay, use other payment method',
    loading: 'Payment confirming',
  },
  bookmark: {
    androidAlert: 'Add Dimorder Restaurant Page to Home Screen',
    androidDownload: 'Download',
    iphoneAlertTitle: '把點單餐廳網頁加到主頁，請使用safari瀏覽器',
    iphoneAlert1: '按下',
    iphoneAlert2: "按鈕，然後按 '加至主頁面'",
  },
  setItemPrice: {
    title: 'Set Item Price',
    price: 'Amount',
    enter: 'Enter',
    cancel: 'Cancel',
  },
}

/**
 * Export
 */
export default messages



// WEBPACK FOOTER //
// ./src/intl/locales/en_US.js